import React from 'react'

const Ball = () => {
  return (
    <div className="ball2"></div>
  )
}

export default Ball